import React, {useState} from 'react';
import 'contents/assets/scss/page/main.scss';
import Paging from '../../component/Inc/Paging';
import PopSpecialMember from './_PopSpecialMember';
function SpeacialMember() {
  const [modalSpecialMember, setModalSpecialMember] = useState(false);
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_4">특별회원 리스트</h2>
          <button onClick={() => setModalSpecialMember(true)} className="com_btn orange s btn_plus">
            특별회원 추가
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>학생명</th>
                  <th>전화번호</th>
                  <th>성별 / 나이</th>
                  <th>지역</th>
                  <th>학교</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>사유</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{17 - idx}</td>
                      <td>가길동104</td>
                      <td>010-1234-4343</td>
                      <td>남 / 2009</td>
                      <td>서울 / 강남구</td>
                      <td>서울고</td>
                      <td>
                        <button className="btn_link">김교사103</button>
                      </td>
                      <td>
                        <button className="btn_link">김담임103</button>
                      </td>
                      <td>이사님 친척분 자제입니다.이사님 친척분 자제입니다.이사님 친척분 자제입니다.이사님 친척분 자제입니다.</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
      <PopSpecialMember open={modalSpecialMember} close={() => setModalSpecialMember(false)} />
    </main>
  );
}

export default SpeacialMember;
